import FocusShader from '../../outline.shader';

export default FocusShader;
